window.theme = window.theme || {};

window.addEventListener('DOMContentLoaded', function(){  
  console.log('Soar (v1.3.0) by Hawke Media (https://www.hawkemedia.com)');

  theme.utils.summaries();
  theme.utils.initFocusVisiblePolyfill();
  theme.testimonials.init();
  theme.tickers.init();
  theme.columnCountSwitcher.init();
  theme.socialShare.init();
  theme.readMore.init();

  window.dispatchEvent(new CustomEvent('soar:theme:ready'));
});